<template>
    <setup_content title="Модель определения кадастровой стоимости">
        <biTable :data="items">
            <template v-slot:value_params="{ data : cell_data }">
                <router-link v-if="cell_data.title == 'Кадастровый номер типового (эталонного) объекта недвижимости'" :to="'/objects/cadastral_number/' + cell_data.value">{{ cell_data.value }}</router-link>
            </template>
        </biTable>
        
        <div v-if="controller.check_roles([ 'cost' ]) && !controller.not_editable" class="mt-3 d-flex justify-content-center" style="gap: 16px">
            <b-button class="d-flex align-items-center" style="gap: .25rem" variant="primary" v-on:click="calculate">
                <base-icon name="calc"/>Рассчитать кадастровую стоимость
            </b-button>
        </div>

        <elements
            v-if="attrs"
            ref="elements"
            service="cadastral_objects"
            without_add
            without_back_button
            :attrs="attrs"
            :get_many_extra="{ group : controller.group_id }"
            not_able_for_delete
            emit_on_double_click_element
            essence_name_genetive_case="объекта"
            essence_name_for_plural_1="объект"
            essence_name_for_plural_234="объекта"
            essence_name_for_plural_others="объектов"
            :postfix_for_storage_name="`details_reference_${controller.group_id}`"
            with_message_on_empty_get_many
        >
        
            <template v-slot:title><h4>Детализация</h4></template>

        </elements>
    </setup_content>
</template>

<script>
import setup_content from "../setup_assets/content"
import biTable from "../../../../widgets/bi-table"
import api from "../../../../../api";
import attrs from "../../../../../api/attrs";
import elements from "../../../../elements"
import Reference_controller from "./controller";

export default {
    props :
	{
		data : Object,
        controller : Reference_controller
	},

    components :
    {
        setup_content,
        biTable,
        elements
    },

    data()
    {
        return {

            attrs : null,
            items : []

        }
    },

    async beforeMount()
    {
        const _items = []

        const data = this.controller.data

        if (data.selection_type)
        {
            if ((data.selection_type == "По кадастровому номеру" || data.selection_type == "Поиск"))
            {
                _items.push({ title : "Вид типового (эталонного) объекта недвижимости", value : "Реальный" })

                if (data.selection_type == "По кадастровому номеру" && data.cad_num.value)
                {
                    _items.push({ title : "Кадастровый номер типового (эталонного) объекта недвижимости", value : data.cad_num.value, params : true })
                }

                if (data.selection_type == "Поиск" && data.search_object_id)
                {
                    const obj = await this.controller.api.get_obj_by("id", data.search_object_id)

                    if (obj)
                    {
                        _items.push({ title : "Кадастровый номер типового (эталонного) объекта недвижимости", value : obj.name, params : true })
                    }
                }
            }
            else
            {
                _items.push({ title : "Вид типового (эталонного) объекта недвижимости", value : data.selection_type })
            }
        }

        if (data.calc_type)
        {
            _items.push({ title : "Способ расчета УПКС типового (эталонного) объекта недвижимости", value : data.calc_type })

            if (data.calc_type == "Метод сравнения продаж" && data.calc_UPKS != null && data.calc_UPKS != undefined)
            {
                _items.push({ title : "УПКС типового (эталонного) объекта недвижимости", value : api.roundToStr(data.calc_UPKS, 2) })
            }
            else if (data.calc_type == "Данные пользователя" && data.calc_custom_UPKS.value != null)
            {
                _items.push({ title : "УПКС типового (эталонного) объекта недвижимости", value : data.calc_custom_UPKS.value })
            }

        }

        this.items = _items

        var _attrs =
            [
                {
                    attr_key : "attrs.CadastralNumber",
                    visible : true,
                    visible_if_no_visible : true,
                    is_cadastral_number : true,
                },
                {
                    attr_key : "attrs.Area",
                    visible : true,
                    visible_if_no_visible : true,
                },
                {
                    attr_key : "attrs.cost_comparative",
                    visible : true,
                    visible_if_no_visible : true,
                    my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
                },
                {
                    attr_key : "attrs.UPKS_comparative",
                    visible : true,
                    visible_if_no_visible : true,
                    my_formatter : elem => { return { value : api.format_cost(elem.value, "", "") } },
                },
            ]

        attrs.get(this).then(({ attrs }) => {
            this.controller.data.factors.forEach(
                attr_id =>
                {
                    const attr = attrs.find((attr) => attr.id == attr_id)

                    if (attr)
                    {
                        var reference = null
        
                        if(_attrs.findIndex(_attr => _attr.attr_key == attr.key) >= 0)
                            return
        
                        if(attr.reference != null)
                        {
                            reference = []
        
                            attr.reference.values.forEach(value => reference.push({ label : api.format_reference(attr.reference, value), value : value }))
                        }
        
                        _attrs.push(
                        {
                            key : "current_version." + attr.key,
                            label : attr.name,
                            sortable : true,
                            visible : false,
                            in_query : true,
                            type : attr.type,
                            reference : { simple_values : reference },
                        })
                    }
                })
    
            this.attrs = _attrs
        })

    },

    methods :
    {
		calculate()
        {
            // TODO Удалить после мультиметодовости

			if (this.controller.check_roles([ 'cost' ]) && !this.controller.not_editable)
			{
				api.call_long_operation(this, "Группа / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_groups", "set_cost",
					{ id : this.controller.group_id, calculation_types : [ "Сравнительный подход" ], evaluate_result_cost : false },
					response =>
					{
						api.open_response_url(response)

						this.$refs.elements.refresh()
					},
					{ success_msg : "Расчет КС завершен" }
				)
			}
        }
    }
}
</script>
